module.exports = __webpack_public_path__ + "img/solomko.48c91d3f.png";